import { render, staticRenderFns } from "./PersonSelect.vue?vue&type=template&id=d24b9a12&scoped=true&"
import script from "./PersonSelect.vue?vue&type=script&lang=js&"
export * from "./PersonSelect.vue?vue&type=script&lang=js&"
import style0 from "./PersonSelect.vue?vue&type=style&index=0&id=d24b9a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24b9a12",
  null
  
)

export default component.exports